export const hasPrivilege = (user, section, privilege = null) => {
  if (!user || !user.privileges || !Array.isArray(user.privileges)) return false;

  const privilegeObject = user.privileges.find(p => p[section]);
  if (privilegeObject && !privilege) {
    return privilegeObject[section].length > 0;
  }
  return privilegeObject && privilegeObject[section]?.includes(privilege);
};